import { h } from "preact";
import { useState, useContext, } from "preact/hooks";
import { AppContext } from "../../AppContext";
import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Stack, Typography } from "@mui/material";

export default function AcceptBidDialogProspect(props) {

	const app = useContext(AppContext);
	const [state, setState] = useState({ mode: "step_1" });
	const handleClose = () => {
		props.onClose();
	};

	const handleAccept = () => {
		console.log("handleAccept", props);
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/acceptbid/" + props.state.params.bid.id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog"><Typography variant="h5" gutterBottom>L'offre du vendeur</Typography></DialogTitle>
			<DialogContent dividers>
				{state.mode === "step_1" && <Stack>
					<Typography variant="h5" gutterBottom>
						Voulez-vous accepter l'offre à {props.state.params.bid.cp} € ?
					</Typography>
					<Typography variant="body1" gutterBottom>
						Offre valable jusqu'au {props.state.params.bid.td}
					</Typography>
				</Stack>}
				{state.mode === "step_2" && <Stack>
					<Typography variant="h5" gutterBottom>
						Voulez-vous vraiment accepter l'offre à {props.state.params.bid.cp} € ?
					</Typography>
				</Stack>}


			</DialogContent>
			<DialogActions>
				{state.mode === "step_1" && <Box display="flex" justifyContent="space-between" alignItems="space-between" style="width: 100%">
					<Box>
						<Button variant="contained" onClick={() => setState({ mode: "step_2" })} style="margin: 10px;">
							OUI
						</Button>
					</Box>
					<Box>
						<Button
							variant="contained"
							onClick={() => app.refPopUp.current.handleChangeState(
								{
									opened: true,
									type: "021",
									params: {
										uid: props.state.params.bid.st,
										prev: false,

									}
								})} style="margin: 10px;">
							Je contre-propose
						</Button>
					</Box>
				</Box>}
				{state.mode === "step_2" && <Box display="flex" justifyContent="space-between" alignItems="center" style="width: 100%">
					<Box>
						<Button variant="contained" onClick={() => setState({ mode: "step_1" })} style="margin: 10px;">
							NON
						</Button>
					</Box>
					<Box>
						<Button variant="contained" onClick={handleAccept} style="margin: 10px;">
							J'ACCEPTE l'offre
						</Button>
					</Box>
				</Box>}
			</DialogActions>
		</Dialog>
	);
}
